import axios, { AxiosInstance } from "axios";
import { ServiceConfig } from "@/container/ServiceConfig";

export default class StatusService {
  private readonly client: AxiosInstance;
  private readonly config: ServiceConfig;

  constructor(config: ServiceConfig) {
    if (!config.baseUrl) {
      throw new Error("You must specify a baseUrl in the service configuration");
    }

    this.config = config;
    this.client = axios.create({
      baseURL: config.baseUrl,
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }
    })
  }

  private async createAuthHeaders(): Promise<Record<string, string>> {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json'
    };

    if (this.config.subscriptionKey) {
      headers['Ocp-Apim-Subscription-Key'] = this.config.subscriptionKey;
    }

    return headers;
  }

  private getApiVersion(): string {
    return this.config.subscriptionKey ? '' : 'v2/';
  }

  async status(): Promise<unknown> {
    return this.submitWithAuth<unknown>("status", {});
  }

  // Helpers
  private async submitWithAuth<T>(endpoint: string, payload: unknown) {
    const headers = await this.createAuthHeaders();
    const url = `Devops/v2/${endpoint}`;

    return new Promise<T>((resolve, reject) => {
      // Status endpoint uses GET method, not POST
      const method = endpoint === 'status' ? 'get' : 'post';
      const request = method === 'get' 
        ? this.client.get(url, { headers })
        : this.client.post(url, payload, { headers });

      request
        .then(resp => {
          const data = resp.data;
          // Transform status response to match expected format
          if (endpoint === 'status' && data) {
            const transformedData = {
              status: data.status,
              statusMessage: data.statusmsg || data.statusMessage,
            };
            resolve(transformedData as unknown as T);
          } else {
            resolve(data);
          }
        })
        .catch(error => reject(error));
    });
  }
}